import React from 'react';
import { ArrowLeft, ChevronLeft, ChevronRight, Copy } from 'lucide-react';
import { toast } from 'sonner';
import { format } from 'date-fns';
import { Button } from '@/components/ui/button';

export const formatSubmitted = (iso) => {
  try { return format(new Date(iso), 'd MMM yyyy, h:mm a'); } catch { return iso || ''; }
};

export function DetailNav({ onBack, prevId, nextId, onGo }) {
  return (
    <div className="flex items-center justify-between gap-3 flex-wrap" data-testid="response-detail-nav">
      <Button variant="ghost" onClick={onBack} className="-ml-3 text-[#1A3E6F] hover:bg-[#1A3E6F]/5" data-testid="response-detail-back-btn">
        <ArrowLeft className="w-4 h-4 mr-2" /> Back to Responses
      </Button>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" disabled={!prevId} onClick={() => onGo(prevId)} data-testid="response-detail-prev-btn">
          <ChevronLeft className="w-4 h-4 mr-1" /> Previous
        </Button>
        <Button variant="outline" size="sm" disabled={!nextId} onClick={() => onGo(nextId)} data-testid="response-detail-next-btn">
          Next <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </div>
  );
}

export function DetailHeader({ responseRef, branchName, submittedAt, surveyName }) {
  const copy = async () => {
    try { await navigator.clipboard.writeText(responseRef); toast.success('Response ID copied'); } catch { toast.error('Could not copy'); }
  };
  return (
    <header className="bg-white border border-[#E2E8F0] rounded-2xl p-5 sm:p-6" data-testid="response-detail-header">
      {surveyName && <p className="text-xs text-[#64748B] mb-2" data-testid="response-detail-survey">{surveyName}</p>}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-[#64748B] mb-1">Response ID</p>
          <div className="flex items-center gap-2">
            <code className="text-base sm:text-lg font-semibold text-[#0F172A] tracking-wide break-all" data-testid="response-detail-id">{responseRef}</code>
            <button type="button" onClick={copy} className="p-1.5 rounded-md text-[#64748B] hover:bg-[#F1F5F9] hover:text-[#1A3E6F] transition-colors" aria-label="Copy Response ID" data-testid="response-detail-copy-id">
              <Copy className="w-4 h-4" />
            </button>
          </div>
        </div>
        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-[#64748B] mb-1">Branch</p>
          <p className="text-base font-semibold text-[#0F172A]" data-testid="response-detail-branch">{branchName}</p>
        </div>
        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-[#64748B] mb-1">Submitted</p>
          <p className="text-base font-semibold text-[#0F172A]" data-testid="response-detail-submitted">{formatSubmitted(submittedAt)}</p>
        </div>
      </div>
    </header>
  );
}
